var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalDriversCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8148 11.1868C11.8148 9.15007 13.4654 7.5 15.5005 7.5C17.5357 7.5 19.1884 9.15007 19.1884 11.1868C19.1884 13.2236 17.5379 14.8737 15.5005 14.8737C13.4632 14.8737 11.8126 13.2236 11.8126 11.1868H11.8148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5006 19.0174C14.6523 19.0174 13.8764 19.3206 13.272 19.8259L14.6457 20.8147C14.894 20.9926 15.1841 21.0871 15.4896 21.0871C15.7951 21.0871 16.0808 20.9948 16.327 20.819L17.7292 19.8237C17.1248 19.3206 16.349 19.0174 15.5028 19.0174H15.5006ZM18.494 20.718L17.0061 21.7748C16.5599 22.0912 16.0369 22.2582 15.4896 22.2582C14.9424 22.2582 14.4083 22.0868 13.9599 21.7638L12.5094 20.718C12.1995 21.2387 12.0193 21.8473 12.0193 22.4977H18.9841C18.9841 21.8473 18.8061 21.2387 18.494 20.718ZM22.9753 20.9355C22.8435 20.2983 22.5512 19.2876 21.8457 18.255C20.4325 16.1808 17.9797 14.9219 15.5006 14.9043C15.1424 14.9043 13.8479 14.9087 12.3797 15.5612C10.1797 16.5368 8.53138 18.5164 8.02808 20.9355C7.86105 21.7419 8.46984 22.4999 9.29402 22.4999H10.8479C10.8479 19.9336 12.9358 17.8463 15.5028 17.8463C18.0698 17.8463 20.1578 19.9336 20.1578 22.4999H21.7116C21.7841 22.4999 22.3358 22.4889 22.716 22.0209C23.0962 21.5507 22.9929 21.008 22.9775 20.9377L22.9753 20.9355Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDriversCard);
export default __webpack_public_path__ + "static/media/totalDriversCard.a9239f985658a13a10c48d9bab5ccc7a.svg";
export { ForwardRef as ReactComponent };